import React, { useEffect, useState, useCallback, useMemo } from 'react'
import _ from 'lodash'
import { getIntegration } from 'integrationActions.js'
import { getIsLogged } from 'authSelector.js'
import { useSelector, useDispatch } from 'react-redux'
import * as styled from 'Styled1X2Games'

const provider = 'onextwo'

// LHS nav ALL_GAMES label
const ALL_GAMES = 'All'

const Onextwogames = () => {
  const dispatch = useDispatch()

  const [data, setData] = useState(undefined)

  const [currNavItem, setCurrNavItem] = useState(ALL_GAMES)

  // Group data by group_name value
  const groupedData = !!data ? _.groupBy(data, 'group_name') : undefined

  // Prepare LHS nav labels
  const nav = !!groupedData && [ALL_GAMES, ...Object.keys(groupedData)]

  useEffect(() => {
    const getGames = async () => {
      const data = await dispatch(getIntegration({
        provider,
        method: 'game_list?isMobile=false'
      }))

      setData(JSON.parse(data))
    }

    getGames()
  }, [dispatch, setData])

  return (
    <styled.Wrapper>
      {!!nav && (
        <styled.Nav>
          <styled.NavList>
            {nav.map((navItem, key) => (
              <NavItem navItem={navItem} key={key} currNavItem={currNavItem} setCurrNavItem={setCurrNavItem} />
            ))}
          </styled.NavList>
        </styled.Nav>
      )}
      <styled.Container>
        <styled.Row>
          {!!groupedData && (groupedData[currNavItem] || data).map(game => (
            <Onextwogame key={game.game_id} {...game} />
          ))}
        </styled.Row>
      </styled.Container>
    </styled.Wrapper>
  )
}

export default Onextwogames

const NavItem = ({
  navItem,
  currNavItem,
  setCurrNavItem
}) => {
  const isActive = useMemo(() => navItem === currNavItem, [navItem, currNavItem])

  const onClick = useCallback(() => {
    setCurrNavItem(navItem)
  }, [setCurrNavItem, navItem])

  return (
    <styled.NavItem>
      <styled.NavButton isActive={isActive} onClick={onClick}>
        {_.startCase(navItem)}
      </styled.NavButton>
    </styled.NavItem>
  )
}

const Onextwogame = ({
  game_id: gameId,
  name,
  image
}) => {
  const dispatch = useDispatch()

  const isLogged = useSelector(getIsLogged)

  const onDemoClick = useCallback(async () => {
    const url = await dispatch(getIntegration({
      provider,
      method: `get_game?gameId=${gameId}&realPlay=false&isMobile=false`
    }))

    !!url && window.open(url, 'newWindow', 'resizable,scrollbars,status')
  }, [dispatch])

  const onPlayClick = useCallback(async () => {
    const url = await dispatch(getIntegration({
      provider,
      method: `get_game?gameId=${gameId}&realPlay=true&isMobile=false`
    }))

    !!url && window.open(url, 'newWindow', 'resizable,scrollbars,status')
  }, [dispatch])

  return (
    <styled.Game>
      <styled.GameInside image={image}>
        <styled.GameName>
          {name}
        </styled.GameName>
        <styled.ButtonsWrapper>
          <styled.DemoButton onClick={onDemoClick}>
            Demo
          </styled.DemoButton>
          {isLogged && (
            <styled.PlayButton onClick={onPlayClick}>
              Play
            </styled.PlayButton>
          )}
        </styled.ButtonsWrapper>
      </styled.GameInside>
    </styled.Game>
  )
}